<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import medicionFrecuenciaAPI from "@/services/standards/medicionFrecuencia/medicionFrecuenciaAPI"
import Swal from "sweetalert2";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import ItemAPI from "@/services/items/itemsAPI";
import CheckModal from "@/components/CheckModal"

/**
 * Form elements component
 */
export default {
  page: {
    title: "3.3.2 Medición de la frecuencia de la accidentalidad",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    CheckModal,
    Layout,
    Style,
    PageHeader,
  },
  data() {

    return {
      title: "3.3.2 Medición de la frecuencia de la accidentalidad",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Medición",
        },

        {
          text: "Editar",
          active: true,
        },
      ],

      itemData: null,
      item: null,
      years: [],
      lista: [],
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      medicion: {
        annual_goal: null,
        monthly_goal: null,
        annual_period: 1,
        monthly_period: 1,
        year: null,
        people_know_result: null,
        responsible_measurement: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
    };
  },
  methods: {
    validarNumero() {
      if (this.medicion.monthly_goal <= 0) {
        this.medicion.monthly_goal = 0;
      } else if (this.medicion.monthly_goal > 100) {
        this.medicion.monthly_goal = 100;
      }
      if (this.medicion.monthly_goal !== null) {
        const numeroString = this.medicion.monthly_goal.toString().substring(0, 3);
        this.medicion.monthly_goal = parseInt(numeroString);
      }
      this.medicion.monthly_goal = this.medicion.monthly_goal
    },
    validarNumero2() {
      if (this.medicion.annual_goal <= 0) {
        this.medicion.annual_goal = 0;
      } else if (this.medicion.annual_goal > 100) {
        this.medicion.annual_goal = 100;
      }
      if (this.medicion.annual_goal !== null) {
        const numeroString = this.medicion.annual_goal.toString().substring(0, 3);
        this.medicion.annual_goal = parseInt(numeroString);
      }
      this.medicion.annual_goal = this.medicion.annual_goal
    },
    validarTecla(event) {
      const keyCode = event.keyCode || event.which;
      if (
        (keyCode >= 48 && keyCode <= 57) || // Números del teclado alfanumérico
        (keyCode >= 96 && keyCode <= 105) || // Números del teclado numérico
        keyCode === 8 // Tecla de retroceso
      ) {
        // Permitir la tecla
      } else {
        // Prevenir la tecla si no es válida
        event.preventDefault();
      }
    },

    getItemData() {
      ItemAPI.getItems(36)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
   * This method is used to knows if the user has the permission indicated
   * @param {String} name The name of the permission
   * @param {Array} roles the roles that permitted to access the action 
   * @returns {Boolean} true if the user has the permission indicated or false if no
   */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 36)
        .then(response => {
          this.item = response || null
        })
        .catch(error => {
          console.log(error)
        })
    },

    save() {
      medicionFrecuenciaAPI.update(this.$route.params.id, {
        annual_goal: this.medicion.annual_goal,
        monthly_goal: this.medicion.monthly_goal,
        annual_period: this.medicion.annual_period,
        monthly_period: this.medicion.monthly_period,
        year: this.medicion.year,
        people_know_result: this.medicion.people_know_result,
        responsible_measurement: this.medicion.responsible_measurement,
        companies_id: this.medicion.companies_id,
      })
        .then((response) => {
          const itemChange = {
            companies_id: this.companyID,
            item_id: 36,
            status: 'Pendiente',
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              setTimeout(() => {
                Swal.fire({
                  title: "¡Éxito!",
                  text: "¡Informacion actualizada con éxito!",
                  type: "success",
                  icon: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                this.$router.go(-1);
              }, 1000)
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getShow() {
      medicionFrecuenciaAPI
        .show(this.$route.params.id)
        .then((response) => {
          this.medicion = {
            annual_goal: response.annual_goal,
            monthly_goal: response.monthly_goal,
            annual_period: response.annual_period,
            monthly_period: response.monthly_period,
            year: response.year,
            people_know_result: response.people_know_result,
            responsible_measurement: response.responsible_measurement,
            companies_id: response.companies_id,
          };
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      medicionFrecuenciaAPI.getAll(this.companyID)
        .then((response) => {
          this.lista = response.data.data;
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    rangeYear() {
      const max = 2040
      const min = 2019
      for (let i = min; i <= max; i++) {
        this.years.push(i)
      }
      return this.years
    },

    goPage(page) {
      window.location.href = page
    },

  },

  mounted() {
    this.rangeYear();
    this.getList();
    this.getItems();
    this.getItemData();
    this.getShow();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12  m-0 p-0">
        <div class="card">
          <div class="card-body  ">
            <div class="row">
              <div class="col-12 text-right m-b-0">
                <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                  <i class="fas fa-arrow-left"></i>
                </div>
                <b-tooltip target="back" placement="left"> Volver </b-tooltip>
              </div>
            </div>

            <hr>

            <form class="form-group" @submit.prevent="save">

              <div class="table-responsive px-4 mt-2" v-if="getRole('Consultar')">
                <table class=" table-sm pt-2 table border-bottom divide-y divide-gray-200 table-bordered rounded">
                  <thead class="bg-primary text-light">
                    <tr>
                      <th class="text-center align-middle" colspan="4">Ficha tecnica del indicador</th>
                    </tr>
                    <tr>
                      <th class="text-center align-middle">Nombre indicador</th>
                      <th class="text-center align-middle" colspan="3">Frecuencia de accidentalidad</th>
                    </tr>
                  </thead>
                  <tbody class="">
                    <tr>
                      <td class=" bg-primary text-light text-center align-middle">
                        <b>Formula</b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        (Número de accidentes de trabajo en el mes / número de trabajadores en el mes) * 100
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Meta</b>
                      </td>
                      <td class="text-center align-middle">
                        <b-form-input class="col-md-4 " type="text" id="date_exam" v-model="medicion.monthly_goal"
                          @keydown="validarTecla" @input="validarNumero" maxlength="3">
                        </b-form-input>
                      </td>
                      <td class="text-center align-middle">
                        <b-form-input class="col-md-4 " type="text" id="date_exam" v-model="medicion.annual_goal"
                          @keydown="validarTecla" @input="validarNumero2" maxlength="3">
                        </b-form-input>
                      </td>
                      <td class="text-center align-middle">
                        <select required class=" col-md-8 form-control" v-model="medicion.year">
                          <b-form-select-option v-for="item in years" :value="item">
                            {{ item }}
                          </b-form-select-option>
                        </select>
                      </td>

                      <td class="text-center align-middle" hidden>
                        <b-form-input class="col-md-4 " type="number" id="date_exam"
                          :value="medicion.monthly_goal === null || medicion.monthly_goal === 0 ? 0 : 1"
                          v-model="medicion.monthly_period">
                        </b-form-input>
                      </td>
                      <td class="text-center align-middle" hidden>
                        <b-form-input class="col-md-4 " type="number" id="date_exam"
                          :value="medicion.annual_goal === null || medicion.annual_goal === 0 ? 0 : 1"
                          v-model="medicion.annual_period">
                        </b-form-input>
                      </td>

                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Periocidad</b>
                      </td>
                      <td class="text-center align-middle">
                        Mensual
                      </td>
                      <td class="text-center align-middle">
                        Anual
                      </td>
                      <td class="text-center align-middle">

                      </td>

                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Fuente de la información</b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        <p>Número de trabajadores en el mes</p>
                        <p>Número de accidentes de trabajo en el mes</p>

                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Personas que deben conocer el resultado</b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        <b-form-input type="text" id="date_exam" maxlength="200" v-model="medicion.people_know_result">
                        </b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Responsable de la medición </b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        <b-form-input type="text" id="date_exam" maxlength="200"
                          v-model="medicion.responsible_measurement">
                        </b-form-input>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="form-group text-right m-b-0  mt-3">
                  <button @click="" type="submit" name="boton" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>